import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoutesProtector = ({ requiredAuth }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  if (isAuthenticated) {
    return requiredAuth ? <Outlet /> : <Navigate to={'/'} />;
  } else {
    return requiredAuth ? <Navigate to={'/login'} /> : <Outlet />;
  }
};

export default PrivateRoutesProtector;
